import { render, staticRenderFns } from "./PurchaseReport.vue?vue&type=template&id=2ddba280&"
import script from "./PurchaseReport.vue?vue&type=script&lang=js&"
export * from "./PurchaseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddba280')) {
      api.createRecord('2ddba280', component.options)
    } else {
      api.reload('2ddba280', component.options)
    }
    module.hot.accept("./PurchaseReport.vue?vue&type=template&id=2ddba280&", function () {
      api.rerender('2ddba280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/PurchaseReport.vue"
export default component.exports